// Get Static Data
export const GET_STATIC_DATA_REQUEST = 'GET_STATIC_DATA_REQUEST';
export const GET_STATIC_DATA_SUCCESS = 'GET_STATIC_DATA_SUCCESS';
export const GET_STATIC_DATA_ERROR = 'GET_STATIC_DATA_ERROR';
export const FETCH_UNDERLYING_MERCHANT_STATIC_REQUEST =
    'FETCH_UNDERLYING_MERCHANT_STATIC_REQUEST';
export const FETCH_UNDERLYING_MERCHANT_STATIC_SUCCESS =
    'FETCH_UNDERLYING_MERCHANT_STATIC_SUCCESS';
export const FETCH_UNDERLYING_MERCHANT_STATIC_ERROR =
    'FETCH_UNDERLYING_MERCHANT_STATIC_ERROR';
export const FETCH_STATIC_INFO_REQUEST = 'FETCH_STATIC_COMMON_INFO_REQUEST';
export const FETCH_STATIC_INFO_SUCCESS = 'FETCH_STATIC_COMMON_INFO_SUCCESS';
export const FETCH_STATIC_INFO_ERROR = 'FETCH_STATIC_COMMON_INFO_ERROR';
export const FETCH_AUDIT_TRAIL_STATIC_REQUEST =
    'FETCH_AUDIT_TRAIL_STATIC_REQUEST';
export const FETCH_AUDIT_TRAIL_STATIC_SUCCESS =
    'FETCH_AUDIT_TRAIL_STATIC_SUCCESS';
export const FETCH_AUDIT_TRAIL_STATIC_ERROR = 'FETCH_AUDIT_TRAIL_STATIC_ERROR';

export const FETCH_CHARGEBACK_STATIC_DATA_REQUEST =
    'FETCH_CHARGEBACK_STATIC_DATA_REQUEST';
export const FETCH_CHARGEBACK_STATIC_DATA_SUCCESS =
    'FETCH_CHARGEBACK_STATIC_DATA_SUCCESS';
export const FETCH_CHARGEBACK_STATIC_DATA_ERROR =
    'FETCH_CHARGEBACK_STATIC_DATA_ERROR';
